
import { Options, Vue } from 'vue-class-component'
import { useStore } from '@/store'

@Options({
  computed: {
    state: String,
    stateClass: String,
    podString: String
  }
})
export default class AdminWeb extends Vue {
  store = useStore()

  get state (): string {
    return `${this.store.state.serviceMeta.running > 0 ? 'Running' : 'Stopped'} [${this.store.state.serviceMeta.running} of ${this.store.state.serviceMeta.wanted} wanted replica]`
  }

  get stateClass (): string {
    return this.store.state.serviceMeta.running > 0 ? 'text-success' : 'text-danger'
  }
}
